/* import __COLOCATED_TEMPLATE__ from './pix-checkbox.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { warn } from '@ember/debug';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import { formatMessage } from '../translations';
let PixCheckbox = (_class = class PixCheckbox extends Component {
  constructor() {
    super(...arguments);
  }
  get id() {
    return this.args.id || guidFor(this);
  }
  get stateId() {
    return `${this.id}-state`;
  }
  get hasSuccessState() {
    return this.args.state === 'success';
  }
  get hasErrorState() {
    return this.args.state === 'error';
  }
  get inputClasses() {
    const classes = ['pix-checkbox__input'];
    if (this.args.isIndeterminate) {
      classes.push(`${classes[0]}--indeterminate`);
    }
    if (this.hasSuccessState || this.hasErrorState) {
      classes.push(`${classes[0]}--state`);
    }
    return classes.join(' ');
  }
  get isDisabled() {
    warn('PixCheckbox: @isDisabled attribute should be a boolean.', [true, false, undefined, null].includes(this.args.isDisabled), {
      id: 'pix-ui.checkbox.is-disabled.not-boolean'
    });
    return this.args.isDisabled || this.args.disabled ? 'true' : null;
  }
  avoidCheckedStateChangeIfIsDisabled(event) {
    if (this.args.isDisabled) {
      event.preventDefault();
    }
  }
  get stateSuccessMessage() {
    return this.formatMessage('state.success');
  }
  get stateErrorMessage() {
    return this.formatMessage('state.error');
  }
  formatMessage(message) {
    return formatMessage('fr', `input.${message}`);
  }
}, _applyDecoratedDescriptor(_class.prototype, "avoidCheckedStateChangeIfIsDisabled", [action], Object.getOwnPropertyDescriptor(_class.prototype, "avoidCheckedStateChangeIfIsDisabled"), _class.prototype), _class);
export { PixCheckbox as default };